import {Colors} from '@wandb/common/css/globals.styles';
import styled from 'styled-components';

export const Panel = styled.div`
  margin: 12px;
`;
Panel.displayName = 'S.Panel';

export const Spacer = styled.div`
  height: 4px;
`;
Spacer.displayName = 'S.Spacer';

export const Runs = styled.div`
  max-height: 400px;
  overflow: auto;
`;
Runs.displayName = 'S.Runs';

export const Run = styled.div`
  padding: 8px;
  cursor: pointer;
  &:hover {
    background-color: ${Colors.GRAY_100};
  }
`;
Run.displayName = 'S.Run';

export const RunNameRow = styled.div`
  display: inline-flex;
  align-items: center;
`;
RunNameRow.displayName = 'S.RunNameRow';

export const Timestamp = styled.div`
  color: ${Colors.GRAY_500};
  font-size: 14px;
`;
Timestamp.displayName = 'S.Timestamp';
